import styled from 'styled-components';

const DivMyClassInfo = styled.div`
  margin-left: auto;
  font-size: 15px;
`;

export default DivMyClassInfo;
